import script from "./AdminAnnouncement.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAnnouncement.vue?vue&type=script&setup=true&lang=js"

import "./AdminAnnouncement.vue?vue&type=style&index=0&id=aa925cd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa925cd6"]])

export default __exports__